// @vendors
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

// @assets
import { theme } from '../../../assets/theme';

// @components
import { AddIcon, Link} from '../../../components/shared/MaterialUI';
import AppButton from '../../../components/forms/AppButton';

// @constants
import { ROUTENAME } from '../../../navigation/RouteName';
import { isRyzeOrganization } from '../../../helpers/FunctionsUtils';
import { GeneralStyles } from '../../../assets/css/general-style';

export const AddNewEmployer = () => {
  const generalStyle = useMemo(() => GeneralStyles(), []);
  const organization = useSelector((state) => state?.organizationReducer?.organizationSelected);

  return (
    <Link
      href={ROUTENAME.createEmployer}
      sx={{ textDecoration: 'none',  pointerEvents: isRyzeOrganization(organization) ? 'none' : 'auto' }}
    >
      <AppButton
        onPress={() => {}}
        label="Add New Employer"
        color="primary"
        bgColor={theme.palette.primary.black}
        endIcon={<AddIcon />}
        sx={generalStyle.customButtonMain}
      />
    </Link>
  );
};
